const STATE_EVENT_PREFIX = 'listings:state:'

class ResultsEventBus {
  constructor () {
    this.events = {}
    this.lastPublished = {}
  }

  subscribe (eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)

    if (
      eventName.startsWith(STATE_EVENT_PREFIX) &&
      Object.prototype.hasOwnProperty.call(this.lastPublished, eventName)
    ) {
      callback(this.lastPublished[eventName])
    }
  }

  unsubscribe (eventName, callback) {
    if (!this.events[eventName]) return
    this.events[eventName] = this.events[eventName].filter(
      cb => cb !== callback,
    )
  }

  publish (eventName, data) {
    if (eventName.startsWith(STATE_EVENT_PREFIX)) {
      this.lastPublished[eventName] = data
    }
    if (!this.events[eventName]) return
    this.events[eventName].forEach(callback => callback(data))
  }
}

class AutocompleteEventBus {
  constructor () {
    this.events = {}
  }

  subscribe (eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)
  }

  unsubscribe (eventName, callback) {
    if (!this.events[eventName]) return
    this.events[eventName] = this.events[eventName].filter(
      cb => cb !== callback,
    )
  }

  publish (eventName, data) {
    if (!this.events[eventName]) return
    this.events[eventName].forEach(callback => callback(data))
  }
}

window.theme = window.theme || {}
window.theme.results = window.theme.results || {}
window.theme.results.templates = window.theme.results.templates || {}
window.theme.results.eventBus = new ResultsEventBus()

window.theme = window.theme || {}
window.theme.autocomplete = window.theme.autocomplete || {}
window.theme.autocomplete.templates = window.theme.autocomplete.templates || {}
window.theme.autocomplete.eventBus = new AutocompleteEventBus()
